import axios from 'axios';
import { API_BASE_URL, buildHeaders } from 'utils/services';

export const fetchExanteAvailable = async (user) => {
  try {
      const { data } = await axios.get(`${API_BASE_URL}/agbk/exante`, buildHeaders(user))
      return data?.data?.available
  } catch (error) {
      console.error('exante', error)
      return null;
  }
}